<template>
  <div class="col-12 bg-white rounded mt-n3">
    <validation-observer
      ref="returnToPreviousStatusForm"
      v-slot="{}"
      tag="form"
    >
      <div class="row mb-n3">
        <div class="col-12 mt-2">
          <p>
            <i
              class="h6 fas fa-calendar-alt text-orange mr-2 font-weight-bold"
            />
            <span class="font-weight-bold color-gray-7">
              {{ title }}
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <validation-provider
            v-slot="{ errors }"
            name="licenseDueDate"
            rules="required"
          >
            <label class="data-title mb-0">Fecha:</label>
            <custom-date-picker
              v-model="model.contractServiceStartDate"
              :class-container="'w-100'"
              :custom-error-msg="'La fecha es requerida.'"
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :max-date="maxDraftedDate"
              :min-date="getMinimunDateInclusive"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mr-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="submitForm()"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import moment from 'moment';
import { ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomDatePicker from 'custom-date-picker';

import { addOrUpdateContractServiceStartDate as _addOrUpdateContractServiceStartDate } from '@/services/uspqrp/contract.api.js';

export default {
  name: 'ContractAssignStartDate',
  components: {
    ValidationProvider,
    ActionButton,
    CustomDatePicker,
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    contractAssignStartDateValidations: {
      type: Object,
      required: true,
      default: () => {},
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        contractServiceStartDate: null,
      },
    };
  },
  computed: {
    title() {
      return this.isEditing
        ? 'Modificar Fecha de Comienzo'
        : 'Asignar Fecha de Comienzo';
    },
    getMinimunDateInclusive() {
      return moment(this.contractAssignStartDateValidations.minDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss');
    },
    maxDraftedDate() {
      return this.data.hasBilling
        ? this.data.maxDraftedDate
        : this.contractAssignStartDateValidations?.maxDate;
    },
  },
  mounted() {
    if (this.data && this.data.contractServiceStartDate) {
      this.model.contractServiceStartDate = this.data.contractServiceStartDate;
    }
  },
  methods: {
    async submitForm() {
      const isFormValid = await this.$refs.returnToPreviousStatusForm.validate();
      if (!isFormValid) {
        this.ShowToast('Alerta', 'La fecha es requerida.', 'error');
        return;
      }
      await this.submitContractServiceStartDate();
    },
    async submitContractServiceStartDate() {
      const warningMessage = this.isEditing
        ? `¿Está seguro(a) que desea modificar la fecha de comienzo? `
        : `¿Está seguro(a) que desea asignar la fecha de comienzo?`;
      const successMessage = this.isEditing
        ? `La fecha de comienzo ha sido actualizada exitosamente. `
        : `La fecha de comienzo ha sido asignada exitosamente.`;

      const answer = await this.ShowCancelModal(
        'Confirmación',
        warningMessage,
        'Sí',
        'No'
      );

      if (!answer) {
        return;
      }

      const payload = {
        contractId: this.data.contractId,
        ...this.model,
      };
      const { data } = await _addOrUpdateContractServiceStartDate(
        payload
      ).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data) this.ShowToast(`Confirmación`, successMessage, 'success');

      this.$emit('save', data);
    },
  },
};
</script>
